class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.searchContainer = this.querySelector('.model__search__main');
    this.closeBtn = this.querySelector('button[type="button"]');

    // ✅ If required markup isn’t present, do nothing (prevents crashing the whole page)
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.addEventListener('mouseenter', this.onSummaryMouseEnter.bind(this));
    this.summaryToggle.addEventListener('mouseleave', this.onSummaryMouseLeave.bind(this));

    // ✅ Only bind if present
    if (this.searchContainer) {
      this.searchContainer.addEventListener('mouseenter', this.onSummaryMouseEnter.bind(this));
      this.searchContainer.addEventListener('mouseleave', this.onSummaryMouseLeave.bind(this));
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return !!this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;
    details.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (!this.detailsContainer) return;

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    const details = event.target && event.target.closest ? event.target.closest('details') : this.detailsContainer;
    if (!details) return;

    details.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Guard trapFocus targets
    const focusEl = this.detailsContainer.querySelector('[tabindex="-1"]');
    const inputEl = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (typeof trapFocus === 'function' && focusEl && inputEl) {
      trapFocus(focusEl, inputEl);
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }

    this.detailsContainer.removeAttribute('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }

  onSummaryMouseEnter(event) {
    if (window.innerWidth < 990) return;
    if (!this.isOpen()) this.open(event);
  }

  onSummaryMouseLeave() {
    if (window.innerWidth < 990) return;
    if (this.isOpen()) this.close();
  }
}

customElements.define('details-modal', DetailsModal);
